/* ONE ICON PER TAB, the same everywhere (Max 01/11: the Staff Purchase tab bar — "ok và đẹp á … chỉnh theo hướng
   design này giúp tôi cho đồng bộ toàn portal"). Every first-level tab bar is a `.view-tabs` row (ViewTabs.css) and
   each tab carries its icon from here, so a word means the same picture on every screen (Pending is always a clock,
   Settings always a cog). Keys are the screens' own tab keys; where two screens use one key for different things the
   call site prefixes it (dx-all, st-all). An unknown key draws nothing — a tab never breaks for want of an icon. */
import React from 'react';
import {
  Activity, BarChart3, BookOpen, Boxes, Briefcase, Building2, Calculator, CalendarCheck, CalendarDays, CalendarRange, CheckCircle2,
  CheckSquare, CircleDashed, Clock, Database, Factory, FileSpreadsheet, FileText, Fuel, GitBranch, HelpCircle, History, Inbox,
  KanbanSquare, Layers, LayoutDashboard, Library, Link2, ListChecks, ListOrdered, Lock, MapPin, MessageSquare, Newspaper,
  Package, PauseCircle, PenLine, PieChart, Play, Send, Settings, Share2, ShoppingCart, Tags, Target, Ticket, Timer,
  TrendingUp, Truck, Upload, User, Users, XCircle,
} from 'lucide-react';

const ICONS = {
  // approval queues
  pending: Clock, waiting: Clock, progress: Timer, rejected: XCircle, approved: CheckCircle2, closed: CheckCircle2,
  // overviews and dashboards
  overview: LayoutDashboard, dash: LayoutDashboard, dashboard: LayoutDashboard, summary: BarChart3, docs: FileText, actual: Activity,
  // data work
  loads: Database, runs: Play, customers: Building2, skus: Package, held: PauseCircle, hjpn: Upload, layers: Layers,
  transit: Truck, class: Tags, map: Link2, buyers: Users, sales: ShoppingCart, position: Target, month: CalendarDays,
  cause: PieChart, wow: TrendingUp, tiers: ListOrdered, supply: Truck, settings: Settings,
  // Driver's Log
  entry: PenLine, places: MapPin, people: Users, gas: Fuel, close: Lock, report: BarChart3,
  // cash
  weekly: CalendarDays, plan: CalendarRange, monthend: CalendarCheck,
  // S&P hub, product line, capacity, demand
  connections: Link2, style: Briefcase, material: Boxes, ready: CheckCircle2, open: HelpCircle, norule: CircleDashed, rules: ListChecks,
  lines: Factory, months: CalendarDays, forecast: TrendingUp, sku: Package, backtest: History,
  // CEO Office, AI Hub
  tickets: Ticket, leads: Target, daily: Newspaper, ask: MessageSquare, knowledge: BookOpen, lessons: ListChecks, activity: History,
  // Data Explorer home, trackers
  'dx-mine': User, 'dx-shared': Share2, 'dx-all': Library, 'st-all': Layers, 'st-product': BarChart3, codes: Tags,
  // module strips (moduleTabsConfig.js)
  requests: Send, approval: CheckSquare, calculator: Calculator, sheets: FileSpreadsheet, programmes: KanbanSquare,
  tracker: GitBranch, inbox: Inbox,
};

export default function TabIcon({ k, size = 16 }) {
  const Icon = ICONS[k];
  return Icon ? <Icon size={size} aria-hidden="true" /> : null;
}
